import { render, staticRenderFns } from "./TeacherSetting.vue?vue&type=template&id=2d8064c4&scoped=true&"
import script from "./TeacherSetting.vue?vue&type=script&lang=js&"
export * from "./TeacherSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8064c4",
  null
  
)

export default component.exports